<template>
  <div class="row text-left search" style="margin-bottom:0px;">
    <div class="col-xs-12 col-sm-12">
      <div class="row">
        <h4 style="margin-right: 10px">Search & Sort</h4>
        <i
          @click="showSearchClicked"
          style="margin-top: 5px; cursor: pointer"
          :class="{
            'fa fa-chevron-up fa-sm': showSearch,
            'fa fa-chevron-down fa-sm': !showSearch,
          }"
        ></i>
      </div>
      <div class="row" v-show="showSearch">
        <div
          class="col-sm-6"
          style="margin-top: 10px"
          v-if="service.noStates != 1"
        >
          <label>
            <strong>State</strong>
          </label>
          <select
            class="form-control"
            v-model="stateSearchForm.value"
          >
            <option value></option>
            <option v-for="state in utils.states()" :key="state" :value="state">
              {{ state }}
            </option>
          </select>
        </div>
        <div
          class="col-sm-6 col-md-6"
          v-for="field in searchableFields"
          :key="field.id + '_search'"
          style="margin-top: 10px"
        >
          <label
            ><strong>{{ field.name }}</strong></label
          >
          <span v-if="field.type == 'Date'">
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <input
                  class="form-control"
                  type="date"
                  :placeholder="field.name"
                  v-model="field.searchValue_startDate"
                />
                <label style="margin-top: 5px">Start Date</label>
              </div>
              <div class="col-sm-12 col-md-6">
                <input
                  class="form-control"
                  type="date"
                  :placeholder="field.name"
                  v-model="field.searchValue_endDate"
                />
                <label style="margin-top: 5px">End Date</label>
              </div>
            </div>
          </span>
          <span v-else-if="field.type == 'State'">
            <select class="form-control" v-model="field.searchValue">
              <option value></option>
              <option
                v-for="state in utils.states()"
                :key="state"
                :value="state"
              >
                {{ state }}
              </option>
            </select>
          </span>
          <span v-else-if="field.type == 'Y/N'">
            <select class="form-control" v-model="field.searchValue">
              <option value></option>
              <option value="Y">Yes</option>
              <option value="N">No</option>
            </select>
          </span>
          <span v-else-if="field.type == 'Select Dropdown'">
            <select class="form-control" v-model="field.searchValue">
              <option value></option>
              <option
                v-for="option in field.selectOptionsArr"
                :key="option"
                :value="option"
              >
                {{ option }}
              </option>
            </select>
          </span>
          <span v-else-if="field.type == 'Multi Select Dropdown'">
            <select class="form-control" multiple v-model="field.searchValues">
              <option
                v-for="option in field.selectOptionsArr"
                :key="option"
                :value="option"
              >
                {{ option }}
              </option>
            </select>
          </span>
          <span v-else>
            <input
              class="form-control"
              type="text"
              :placeholder="field.name"
              v-model="field.searchValue"
            />
          </span>
        </div>
      </div>
      <div class="row" style="margin-top: 20px" v-show="showSearch">
        <div class="col-sm-12 text-center">
          <button
            @click="clearSearch"
            style="
              width: 200px;
              color: black;
              background-color: white;
              margin-bottom: 10px;
            "
            class="btn"
          >
            Clear
          </button>
          <button
            @click="search"
            style="width: 200px; margin-bottom: 10px"
            class="btn btn-primary btn-blue"
          >
            Search
          </button>
        </div>
      </div>
        <div class="row">
          <div class="col-sm-12">
            <h4 v-show="showSearch" style="margin-right: 10px;width:auto;float:left;margin-top:20px;margin-bottom:20px;">Sort</h4>
          </div>
        </div>
        <div class="row" v-show="showSearch">
          <div
            class="col-xs-6 col-sm-2"
            style="margin: 10px"
            v-for="field in fields"
            :key="field.name"
          >
            <button
              :class="{
                btn: true,
                'btn-default': true,
                'btn-blue': sortedField.name == field.name,
              }"
              @click="sortBy(field)"
            >
              {{ field.name }}
              <span v-if="sortedField.name == field.name">
                <i
                  style="margin-top: 5px; cursor: pointer"
                  :class="{
                    'fa fa-chevron-up fa-sm': sortedDirection == 'DESC',
                    'fa fa-chevron-down fa-sm': sortedDirection == 'ASC',
                  }"
                ></i>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import Utils from "@/Utils/Utils";
export default {
  name: "FeedSearch",
  components: {},
    data() {
    return {
      utils: Utils
    };
  },
  props: {
    fields: {
      default: [],
    },
    showSearch: {
        default:false
    },
    service: {
        default:{}
    },
    stateSearchForm: {
        default:{}
    },
    sortedField: {
      default: Object,
    },
    sortedDirection: {
      default: "DESC",
    },
  },
  computed: {
    searchableFields() {
      return this.fields.filter((it) => {
        return it.searchable == 1;
      });
    },
  },
  methods: {
    clearSearch() {
      this.$emit("clearSearch");
    },
    search() {
      this.$emit("search");
    },
    showSearchClicked() {
        this.$emit("showSearch")
    },
    sortBy(field) {
      this.$emit("sortBy", field);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media (max-width: 768px) {
  .hidden-sm {
    display: none;
  }
}

.white {
  color: white;
}

.search {
  background: #f2f2f2;
  border-radius: 10px;
  margin: 0px;
  padding: 20px;
  margin-bottom: 20px;
}

.small {
  font-size: 90%;
}

.medium {
  font-size: 130%;
}

.large {
  font-size: 170%;
}

.btn-blue {
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/FeedSearch.vue